/** Hero Carousel Slider */

(function(){
  var track = document.getElementById('heroCarousel');
  var slideCount = 3;
  var current = 0;
  var autoplayInterval;
  
  window.goToSlide = function(i) {
    current = i;
    track.scrollTo({
      left: track.clientWidth * current, 
      behavior: 'smooth'
    });
    updateDots();
    resetAutoplay();
  };
  
  function updateDots() {
    var dots = document.querySelectorAll('#heroDots span');
    dots.forEach(function(d, idx) { 
      d.classList.toggle('active', idx === current); 
    });
  }
  
  function resetAutoplay() {
    clearInterval(autoplayInterval);
    autoplayInterval = setInterval(function(){ 
      current = (current + 1) % slideCount;
      track.scrollTo({
        left: track.clientWidth * current, 
        behavior: 'smooth'
      });
      updateDots();
    }, 5000);
  }
  
  track.addEventListener('scroll', function(){
    var idx = Math.round(track.scrollLeft / track.clientWidth);
    if(idx !== current && idx >= 0 && idx < slideCount){ 
      current = idx; 
      updateDots();
    }
  });
  
  // Start autoplay
  autoplayInterval = setInterval(function(){ 
    current = (current + 1) % slideCount;
    track.scrollTo({
      left: track.clientWidth * current, 
      behavior: 'smooth'
    });
    updateDots();
  }, 5000);
  
  // Pause autoplay on hover
  track.addEventListener('mouseenter', function() {
    clearInterval(autoplayInterval);
  });
  
  track.addEventListener('mouseleave', function() {
    resetAutoplay();
  });
  
  // Handle window resize
  window.addEventListener('resize', function() {
    track.scrollTo({
      left: track.clientWidth * current, 
      behavior: 'auto'
    });
  });
})();

/**Shop Photo Gallery */

  function toggleWishlist(btn){
    btn.classList.toggle('wishlisted');
  }
  function addToCartFeedback(btn){
    var feedback = btn.querySelector('.cart-feedback');
    feedback.classList.add('show');
    setTimeout(function(){ feedback.classList.remove('show'); }, 1200);
    var cartCount = document.querySelector('.cart-count');
    if(cartCount){ cartCount.textContent = (parseInt(cartCount.textContent, 10) || 0) + 1; }
  }
  function setupProductGallery(galleryId, dotsId, captionId, captions){
    var gallery = document.getElementById(galleryId);
    var dots = document.querySelectorAll('#' + dotsId + ' span');
    var caption = document.getElementById(captionId);
    gallery.addEventListener('scroll', function(){
      var idx = Math.round(gallery.scrollLeft / gallery.clientWidth);
      dots.forEach(function(d,i){ d.classList.toggle('active', i===idx); });
      if(captions[idx] !== undefined){ caption.innerHTML = captions[idx]; }
    });
  }
  setupProductGallery('productGallery1', 'galleryDots1', 'galleryCaption1',
    ['With a hint of toasted nuts &amp; notes of honey.', 'Hot: 100&deg;C &middot; 3-4 min &nbsp;|&nbsp; Cold brew: 6 hrs', '300 SEK &middot; 35g']);
  setupProductGallery('productGallery2', 'galleryDots2', 'galleryCaption2',
    ['Grassy and vegetal, with a delicate floral sweetness.', 'Hot: 80&deg;C &middot; 2-3 min &nbsp;|&nbsp; Cold brew: 6-8 hrs', 'Price']);
  setupProductGallery('productGallery3', 'galleryDots3', 'galleryCaption3',
    ['Delicate and subtly sweet, with soft floral notes.', 'Hot: 75&deg;C &middot; 2-3 min &nbsp;|&nbsp; Cold brew: 6-8 hrs', 'Price']);
  setupProductGallery('productGallery4', 'galleryDots4', 'galleryCaption4',
    ['Bright and brisk, an everyday cup with real character.', 'Hot: 95&deg;C &middot; 3-4 min &nbsp;|&nbsp; Cold brew: 6 hrs', 'Price']);
  setupProductGallery('productGallery5', 'galleryDots5', 'galleryCaption5',
    ['Classic Assam black, laced with natural bergamot.', 'Hot: 100&deg;C &middot; 3-4 min &nbsp;|&nbsp; Cold brew: 6 hrs', 'Price']);
  setupProductGallery('productGallery6', 'galleryDots6', 'galleryCaption6',
    ['Bold Assam black blended with five warming whole spices.', 'Hot: 100&deg;C &middot; 4-5 min &nbsp;|&nbsp; Cold brew: 6 hrs', 'Price']);